import React, { useState } from "react";
import { Autocomplete, TextField, Chip, Paper } from "@mui/material";

interface SkillsBoxProps {
  skills: string[];
  handleSkills: (skills: string[]) => void;
}

const options: string[] = [
  "Python",
  "Java",
  "C",
  "C++",
  "C#",
  "JavaScript",
  "TypeScript",
  "Ruby",
  "PHP",
  "Swift",
  "Kotlin",
  "Objective-C",
  "Go",
  "Rust",
  "Dart",
  "R",
  "MATLAB",
  "Julia",
  "Groovy",
  "Scala",
  "Haskell",
  "Elixir",
  "Erlang",
  "F#",
  "Lisp",
  "Scheme",
  "Common Lisp",
  "OCaml",
  "Prolog",
  "Smalltalk",
  "Fortran",
  "COBOL",
  "VHDL",
  "Verilog",
  "Ada",
  "D",
  "Nim",
  "Crystal",
  "Zig",
  "Vala",
  "Eiffel",
  "Tcl",
  "Xojo",
  "Chapel",
  "ActionScript",
  "Forth",
  "Bash",
  "Perl",
  "Lua",
  "PowerShell",
  "VBScript",
  "AppleScript",
  "Awk",
  "REXX",
  "Racket",
  "Clojure",
  "Elm",
  "Idris",
  "PureScript",
  "HTML",
  "CSS",
  "CoffeeScript",
  "Handlebars",
  "SAS",
  "SQL",
  "React",
  "Angular",
  "Vue.js",
  "Svelte",
  "Node.js",
  "Express.js",
  "Django",
  "Flask",
  "Ruby on Rails",
  "Spring Boot",
  "ASP.NET",
  "Laravel",
  "Symfony",
  "Next.js",
  "Nuxt.js",
  "Meteor",
  "jQuery",
  "Bootstrap",
  "Tailwind CSS",
  "Material UI",
  "Redux",
  "MobX",
  "GraphQL",
  "Apollo",
  "Socket.io",
  "WebSockets",
  "TensorFlow",
  "PyTorch",
  "Keras",
  "Scikit-learn",
  "Pandas",
  "NumPy",
  "Matplotlib",
  "D3.js",
  "Chart.js",
  "Highcharts",
  "Flutter",
  "React Native",
  "Xamarin",
  "Qt",
  "Electron",
  "PostgreSQL",
  "MySQL",
  "SQLite",
  "MongoDB",
  "Redis",
  "Cassandra",
  "Oracle",
  "Microsoft SQL Server",
  "MariaDB",
  "CouchDB",
  "Neo4j",
  "DynamoDB",
  "Firebase",
  "ElasticSearch",
  "Memcached",
  "InfluxDB",
  "GraphDB",
  "Realm",
  "Git",
  "Docker",
  "Kubernetes",
  "Jenkins",
  "Travis CI",
  "CircleCI",
  "GitLab CI",
  "Ansible",
  "Puppet",
  "Chef",
  "Terraform",
  "Vagrant",
  "Nginx",
  "Apache",
  "AWS",
  "Azure",
  "Google Cloud",
  "Heroku",
  "Netlify",
  "Vercel",
  "Cloudflare",
  "Jira",
  "Confluence",
  "Trello",
  "Bitbucket",
  "JIRA",
  "Selenium",
  "Cypress",
  "JUnit",
  "TestNG",
  "Mocha",
  "Chai",
  "Jasmine",
  "Jest",
  "Webpack",
  "Babel",
  "Parcel",
  "Grunt",
  "Gulp",
  "Yarn",
  "NPM",
  "Maven",
  "Gradle",
  "Linux",
  "Unix",
  "Windows",
  "macOS",
  "Agile",
  "Scrum",
  "Kanban",
  "Waterfall",
  "Lean",
  "Extreme Programming (XP)",
  "Test-Driven Development (TDD)",
  "Behavior-Driven Development (BDD)",
  "Continuous Integration (CI)",
  "Continuous Deployment (CD)",
  "DevOps",
  "Pair Programming",
  "Subversion (SVN)",
  "Mercurial",
  "Perforce",
  "CVS",
  "REST",
  "SOAP",
  "gRPC",
  "JSON",
  "XML",
  "OAuth",
  "JWT",
  "OpenID",
  "SAML",
  "SSL/TLS",
  "HTTP/HTTPS",
  "FTP",
  "SFTP",
  "TCP/IP",
  "UDP",
  "DNS",
  "WebRTC",
  "Encryption",
  "OAuth2",
  "OpenID Connect",
  "HTTPS",
  "Penetration Testing",
  "Vulnerability Scanning",
  "OWASP",
  "Secure Coding",
  "Authentication",
  "Authorization",
  "Firewalls",
  "IDS/IPS",
  "SOC 2 Compliance",
  "ISO 27001",
  "GDPR",
  "PCI-DSS",
  "Security Audits",
  "Android",
  "iOS",
  "FreeBSD",
  "CentOS",
  "Debian",
  "Red Hat",
  "Ubuntu",
  "Unit Testing",
  "Integration Testing",
  "System Testing",
  "End-to-End Testing",
  "Load Testing",
  "Performance Testing",
  "Stress Testing",
  "Security Testing",
  "PyTest",
  "Karma",
  "Microservices",
  "Monolithic Architecture",
  "Serverless",
  "Cloud-Native",
  "Event-Driven Architecture",
  "SOA (Service-Oriented Architecture)",
  "CQRS (Command Query Responsibility Segregation)",
  "MVC (Model View Controller)",
  "MVVM (Model-View-ViewModel)",
  "Design Patterns (Singleton",
  "Factory",
  "Observer",
  "etc.)",
  "Domain-Driven Design (DDD)",
  "SOLID Principles",
  "Problem-Solving",
  "Critical Thinking",
  "Communication",
  "Teamwork",
  "Leadership",
  "Time Management",
  "Adaptability",
  "Creativity",
  "Conflict Resolution",
  "Collaboration",
  "Active Listening",
  "Mentoring",
  "Cross-Functional Collaboration",
  "Presentation Skills",
  "Asana",
  "Basecamp",
  "Monday.com",
  "Microsoft Project",
  "Wrike",
  "ClickUp",
  "Gantt Charts",
  "Burndown Charts",
  "Resource Management",
  "Budgeting",
  "Risk Management",
  "Stakeholder Management",
  "Timeline Planning",
  "OKRs (Objectives and Key Results)",
  "GitHub",
  "GitLab",
  "SourceForge",
  "CodeCommit",
  "Visual Studio Code",
  "IntelliJ IDEA",
  "Eclipse",
  "PyCharm",
  "WebStorm",
  "Android Studio",
  "Xcode",
  "Sublime Text",
  "Vim",
  "Emacs",
  "Amazon Web Services (AWS)",
  "Microsoft Azure",
  "Google Cloud Platform (GCP)",
  "DigitalOcean",
  "IBM Cloud",
  "Oracle Cloud",
  "Alibaba Cloud",
  "ELK Stack",
  "Prometheus",
  "Grafana",
  "Splunk",
  "Datadog",
  "Nagios",
  "SSH",
  "Load Balancers",
  "VPNs",
  "DHCP",
  "Routing",
  "Switching",
  "NAT",
  "VLANs",
  "Data Structures",
  "Algorithms",
  "Object-Oriented Programming (OOP)",
  "Functional Programming",
  "Parallel Programming",
  "Concurrency",
  "Multithreading",
  "Distributed Systems",
  "Big Data",
  "Data Analysis",
  "Machine Learning",
  "Artificial Intelligence",
  "Natural Language Processing",
  "Computer Vision",
  "Data Science",
  "Data Engineering",
  "Cloud Computing",
  "Virtualization",
  "Blockchain",
  "Cryptography",
  "Edge Computing",
  "IoT (Internet of Things)",
  "Web Development",
  "Mobile Development",
  "Game Development",
  "AR/VR Development",
];

const SkillsBox: React.FC<SkillsBoxProps> = ({ skills, handleSkills }) => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>(skills);

  const handleDelete = (optionToDelete: string) => {
    setSelectedOptions((current) =>
      current.filter((option) => option !== optionToDelete)
    );
  };

  React.useEffect(() => {
    handleSkills(selectedOptions);
  }, [selectedOptions]);

  return (
    <div className="rounded-xl bg-[#333333]">
      <Autocomplete
        multiple
        options={options}
        value={selectedOptions}
        onChange={(event, newValue) => {
          setSelectedOptions(newValue);
        }}
        getOptionLabel={(option) => option}
        renderTags={(selected, getTagProps) =>
          selected.map((option, index) => (
            <Chip
              key={option}
              label={option}
              onDelete={() => handleDelete(option)}
              style={{
                fontFamily: "Source Code Pro, sans-serif",
                color: "white",
                fontSize: "18px",
              }}
            />
          ))
        }
        PaperComponent={(props) => (
          <Paper
            {...props}
            style={{
              fontFamily: "Source Code Pro, sans-serif",
              color: "white",
              backgroundColor: "#1E1E1E",
            }} // Apply custom font to dropdown options
          />
        )}
        renderOption={(props, option) => (
          <li
            {...props}
            style={{
              fontFamily: "Source Code Pro, sans-serif",
              color: "white",
            }}
          >
            {option}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Select Skills"
            InputProps={{
              ...params.InputProps,
              style: {
                fontFamily: "Source Code Pro, sans-serif",
                color: "white",
              },
            }}
            InputLabelProps={{
              style: {
                fontFamily: "Source Code Pro, sans-serif",
                color: "white",
              }, // Apply custom font to the label
            }}
          />
        )}
      />
    </div>
  );
};

export default SkillsBox;
